import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { parseApiError } from 'utils/errorParser';
import { activityLogService } from 'services/activityLogService';

export const fetchActivityLogs = createAsyncThunk(
  'activityLogs/fetch',
  async (params, { rejectWithValue }) => {
    try {
      return await activityLogService.list(params);
    } catch (error) {
      return rejectWithValue(parseApiError(error));
    }
  }
);

const activityLogSlice = createSlice({
  name: 'activityLogs',
  initialState: {
    items: [],
    meta: { total: 0, page: 1, pageSize: 20, totalPages: 0 },
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchActivityLogs.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchActivityLogs.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload.items;
        state.meta = {
          total: action.payload.total,
          page: action.payload.page,
          pageSize: action.payload.pageSize,
          totalPages: action.payload.totalPages,
        };
      })
      .addCase(fetchActivityLogs.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload?.message || 'Failed to load activity logs';
      });
  },
});

export default activityLogSlice.reducer;
